<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：状态列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleStateSelect('')"
              :class="{ 'selected': housekeepingServPoolManageInfo.conditions.state === '' }">
              全部
            </li>
            <li v-for="(item, index) in housekeepingServPoolManageInfo.states" :key="index"
              @click="handleStateSelect(item.statusCd)"
              :class="{ 'selected': housekeepingServPoolManageInfo.conditions.state === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" :model="housekeepingServPoolManageInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-form-item>
                <el-input placeholder="请输入服务名称" v-model="housekeepingServPoolManageInfo.conditions.servName">
                </el-input>
              </el-form-item>
            </el-form-item>
            <el-form-item>
              <el-form-item>
                <el-input placeholder="请输入申请人" v-model="housekeepingServPoolManageInfo.conditions.applyName">
                </el-input>
              </el-form-item>
            </el-form-item>
            <el-form-item>
              <el-form-item>
                <el-input placeholder="请输入联系电话" v-model="housekeepingServPoolManageInfo.conditions.applyTel">
                </el-input>
              </el-form-item>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryHousekeepingServPoolMethod()">
                <i class="el-icon-search"></i> 查询
              </el-button>
              <el-button @click="_resetHousekeepingServPoolMethod()">
                <i class="el-icon-refresh"></i> 重置
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 服务工单池表格 -->
        <el-card class="box-card" style="margin-top:20px">
          <div slot="header" class="flex justify-between">
            <span>服务工单池</span>
            <el-button type="primary" style="float: right; padding: 3px 0" @click="_openAddTelSerModal()">
              <i class="el-icon-plus"></i>服务登记
            </el-button>
          </div>
          <el-table :data="housekeepingServPoolManageInfo.housekeepingServPools" border style="width: 100%">
        <el-table-column prop="servName" label="服务名称" align="center"></el-table-column>
        <el-table-column prop="cartId" label="订单编号" align="center">
          <template slot-scope="scope">
            {{ scope.row.cartId == '-1' ? '电话预约' : scope.row.cartId }}
          </template>
        </el-table-column>
        <el-table-column prop="applyName" label="申请人" align="center"></el-table-column>
        <el-table-column prop="applyTel" label="联系方式" align="center"></el-table-column>
        <el-table-column prop="appointmentTime" label="预约时间" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请时间" align="center"></el-table-column>
        <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
        <el-table-column prop="context" label="备注" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.state == '1000' && scope.row.repairWay == '200'" type="text" size="small"
              @click="_openDispatchHousekeepingModel(scope.row)">
              指派
            </el-button>
            <el-button type="text" size="small" @click="_openDetail(scope.row)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange"
        :current-page="housekeepingServPoolManageInfo.conditions.page"
        :page-size="housekeepingServPoolManageInfo.conditions.row" layout="total, prev, pager, next"
        :total="housekeepingServPoolManageInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-owner-repair ref="addOwnerRepair"></add-owner-repair>
    <dispatch-housekeeping ref="dispatchHousekeeping" @refresh="handleRefresh"></dispatch-housekeeping>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { queryHousekeepingServPool } from '@/api/housekeeping/housekeepingServPoolApi'
import AddOwnerRepair from '@/components/goods/addOwnerRepair'
import DispatchHousekeeping from '@/components/goods/dispatchHousekeeping'

export default {
  components: {
    AddOwnerRepair,
    DispatchHousekeeping
  },
  data() {
    return {
      housekeepingServPoolManageInfo: {
        housekeepingServPools: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          servName: '',
          state: '',
          applyName: '',
          applyTel: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._listHousekeepingServPools(1, 10)
      this.getDictData()
    },
    handleRefresh() {
      this._listHousekeepingServPools(this.housekeepingServPoolManageInfo.conditions.page, this.housekeepingServPoolManageInfo.conditions.row)
    },
    async getDictData() {
      try {
        const { data } = await getDict('housekeeping_serv_pool', 'state')
        this.housekeepingServPoolManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listHousekeepingServPools(page, rows) {
      this.housekeepingServPoolManageInfo.conditions.page = page
      this.housekeepingServPoolManageInfo.conditions.row = rows
      try {
        const res = await queryHousekeepingServPool(this.housekeepingServPoolManageInfo.conditions)
        this.housekeepingServPoolManageInfo.total = res.total
        this.housekeepingServPoolManageInfo.records = res.records
        this.housekeepingServPoolManageInfo.housekeepingServPools = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryHousekeepingServPoolMethod() {
      this._listHousekeepingServPools(1, 10)
    },
    _resetHousekeepingServPoolMethod() {
      this.housekeepingServPoolManageInfo.conditions = {
        servName: '',
        state: '',
        applyName: '',
        applyTel: '',
        shopId: '',
        page: 1,
        row: 10
      }
      this._listHousekeepingServPools(1, 10)
    },
    _openAddTelSerModal() {
      this.$refs.addOwnerRepair.open(this.housekeepingServPoolManageInfo.conditions)
    },
    _openDispatchHousekeepingModel(repair) {
      repair.action = "DISPATCH"
      this.$refs.dispatchHousekeeping.open(repair)
    },
    _openDetail(pool) {
      this.$router.push(`/pages/housekeeping/housekeepingServDetail?poolId=${pool.poolId}`)
    },
    handleCurrentChange(val) {
      this._listHousekeepingServPools(val, 10)
    },
    handleStateSelect(state) {
      this.housekeepingServPoolManageInfo.conditions.state = state
      this.housekeepingServPoolManageInfo.conditions.page = 1
      this._listHousekeepingServPools(1, this.housekeepingServPoolManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.el-row {
  margin-bottom: 20px;
}

/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>